module.exports = __webpack_public_path__ + "img/star_blue.b95acf7a.svg";